import { useEffect } from "react";
import Lenis from "lenis";
import "./App.css";
import { Nav } from "./components/Nav";
import { Journey } from "./components/Journey";
import { Marquee } from "./components/Marquee";
import { Services } from "./components/Services";
import { Proof } from "./components/Proof";
import { About } from "./components/About";
import { Faq } from "./components/Faq";
import { RequestForm } from "./components/RequestForm";
import { Payments } from "./components/Payments";
import { Footer } from "./components/Footer";
import { Chat } from "./components/Chat";
import { ContactPill } from "./components/WhatsAppPill";

export default function App() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const lenis = new Lenis({ lerp: 0.11, wheelMultiplier: 1 });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    const onAnchor = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const el = document.querySelector(a.getAttribute("href"));
      if (el) {
        e.preventDefault();
        lenis.scrollTo(el, { offset: 0 });
      }
    };
    document.addEventListener("click", onAnchor);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      document.removeEventListener("click", onAnchor);
    };
  }, []);

  return (
    <div id="top">
      <Nav />
      <main>
        <Journey />
        <Marquee />
        <Services />
        <Proof />
        <About />
        <Faq />
        <RequestForm />
        <Payments />
      </main>
      <Footer />
      <ContactPill />
      <Chat />
    </div>
  );
}
